'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SpinningCircle = require('../SpinningCircle');

var _SpinningCircle2 = _interopRequireDefault(_SpinningCircle);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingScreen = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(LoadingScreen, _React$Component);

  function LoadingScreen() {
    (0, _classCallCheck3.default)(this, LoadingScreen);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingScreen.__proto__ || (0, _getPrototypeOf2.default)(LoadingScreen)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingScreen, [{
    key: 'render',
    value: function render() {
      if (!this.props.loading) return null;

      return _react2.default.createElement(
        'div',
        { styleName: 'blackout' },
        _react2.default.createElement(
          'div',
          { styleName: 'spinner' },
          _react2.default.createElement(_SpinningCircle2.default, null)
        )
      );
    }
  }]);
  return LoadingScreen;
}(_react2.default.Component)) || _class);
exports.default = LoadingScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LoadingScreen/index.js
// module id = 590
// module chunks = 0